export const build = { date:"2026-04-07.1340", stage:"alpha" }
